<template>
    <zen-one title="Dashboard:: Cukai Tanahhhh" :crumbs="crumbs"> </zen-one>
</template>

<script>
export default {
    data() {
        return {
            crumbs: [
                { label: "iHasil", route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
            ],
        };
    },
};
</script>
